type DispatchActionParams = { type: string; payload?: any; };

export const dispatchAction = ({ type, payload }: DispatchActionParams) => {
  if (window.store) {
    window.store.dispatch({ type, payload });
  }
};
